import { Utility } from '@plugins/utility'
import { computed, toValue } from 'vue'

const localUtility = Utility

export const useSortedList = (unsortedList, key) => {
    const sorted = computed(() => localUtility.sortByKey(toValue(unsortedList), key))

    return {
        sorted
    }
}